module.exports = __webpack_public_path__ + "img/column_202306-2.967c143b.jpg";